import { cn } from "kz-ui-sdk";
import { OnboardingDialogStep } from "../../constants";
import { OnboardingDialogProps } from "../../types";
import DialogLayoutRenderer from "../DialogLayoutRenderer";
import PostLoginInfoStep from "../DialogSharedSteps/components/PostLoginInfoStep";
import { ForgotSecretStep, OnboardStep } from "./components";

const DialogUsernamePassword = ({
  isOpen,
  handleClose,
  stepNavigate,
  onboardingMode,
  step,
  callback,
  layout,
  handlePostLoginInfoBack,
  redirectHomeOnSuccess,
  isHidden = false,
}: OnboardingDialogProps) => {
  return (
    <DialogLayoutRenderer
      layout={layout}
      isOpen={isOpen}
      onClose={handleClose}
      isHidden={isHidden}
      classes={{
        drawer: {
          "container&": cn("!px-4 !pb-4"),
        },
      }}
    >
      {/*ONBOARDING STEP*/}
      {/* Mode = MemberSettingAuthMode.UsernamePassword 
        OnboardingStep include:
        - Login Username Password
        - Login Phone OTP
        - Register Username Password
      */}
      {step === OnboardingDialogStep.Onboarding && onboardingMode && (
        <OnboardStep
          defaultMode={onboardingMode}
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*FORGOT PASSWORD STEP*/}
      {step === OnboardingDialogStep.ForgotSecret && (
        <ForgotSecretStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*POST LOGIN INFO STEP*/}
      <PostLoginInfoStep
        step={step}
        stepNavigate={stepNavigate}
        handleClose={handleClose}
        layout={layout}
        callback={callback}
        handleBack={handlePostLoginInfoBack}
        redirectHomeOnSuccess={redirectHomeOnSuccess}
      />
    </DialogLayoutRenderer>
  );
};

export default DialogUsernamePassword;
